import { makeContractChargeDatesRepository } from 'modules/customer/infra/repositories';

import { ChangeContractChargeDateUseCase } from './implementations/ChangeContractChargeDateUseCase';

let instance: ChangeContractChargeDateUseCase | null = null;

export default function makeChangeContractChargeDateUseCase() {
  if (!instance) {
    const repository = makeContractChargeDatesRepository();

    instance = new ChangeContractChargeDateUseCase(repository);
  }

  return instance;
}
